export * from './RatingTextTooltip';
export * from './RatingTextTooltip.type';
